// Returns WordPress core's real jQuery instance — the one
// wp_enqueue_script('jquery') loads and WooCommerce's own bundled scripts
// (wc-add-to-cart.js, wc-add-to-cart-variation.js) are registered against.
//
// This is NOT the same object as this webpack bundle's own `$`/`jQuery`
// (provided by webpack.config.js's ProvidePlugin from node_modules/jquery,
// the copy Slick Carousel is patched onto — see hero-slider.js/product-slider.js).
// Two separate jQuery copies loaded on one page do not share event
// bindings/triggers even when operating on the same DOM node, so code that
// needs to interoperate with a WooCommerce core script (cart-drawer.js,
// product-variations.js) must reach the WP-core instance specifically.
//
// A literal `window.jQuery` reference does NOT work for this: webpack's
// ProvidePlugin statically rewrites every `window.jQuery` member expression
// in this bundle's source to the bundled jquery module (even bracket-notation
// `window['jQuery']`, since webpack's member-chain matching is syntactic, not
// textual). Building the property name at runtime defeats that static
// analysis and forces a genuine property lookup on the browser global.
export function getRealJQuery() {
    const propName = ['j', 'Query'].join('');
    return window[propName];
}
